import { Stack } from "@mantine/core";
import { forwardRef } from "react";
import { AuthorBadge } from "./AuthorBadge";
import { MessageBubble } from "./MessageBubble";
import classes from "./message-component-styles.module.css";

interface CustomerTypingIndicatorProps {
    sessionId: string;
    customerName?: string;
    isLastCustomerMessage: boolean;
}

export const CustomerTypingIndicator = forwardRef<HTMLDivElement, CustomerTypingIndicatorProps>(
    function CustomerTypingIndicator({ sessionId, customerName, isLastCustomerMessage }, ref) {
        return (
            <Stack align="flexAlign" justify="flexAlign" mb="lg" gap="xs" ref={ref}>
                {!isLastCustomerMessage && ( //TODO: make sure this logic is correct
                    <AuthorBadge
                        senderType="customer"
                        senderId="customer"
                        customerName={customerName ?? "Customer"}
                        sessionId={sessionId}
                        dateCreated={null} // No date for typing indicator
                    />
                )}
                <MessageBubble lastOfGroup={true} senderType="customer" flexAlign="flex-start" maw="80%" p="md">
                    <span className={classes.customer_typing_indicator}>
                        {"Customer is typing "}
                        <span className={classes.typing_ellipsis}>
                            <span>.</span>
                            <span className={classes.dot2}>.</span>
                            <span className={classes.dot3}>.</span>
                        </span>
                    </span>
                </MessageBubble>
            </Stack>
        );
    },
);
